import React from 'react';

import NavBar from '../../components/common/navbar';
import EntityRuleList from '../../components/EntityRule/entity_rule_list';
import SideBar from '../../components/modules/left_sidebar';

const Administration = false;

class EntityRuleListPage extends React.Component {
  render() {
    const topBarMenu = this.props.location && this.props.location.state && this.props.location.state.topBarMenu;
    return (
      <div className="dashboard">
        <NavBar topBarMenuOption={topBarMenu} moduleName="Administration" />
        <SideBar Administration={Administration} />
        <div className="container-fluid">
          <EntityRuleList topBarMenuOption={topBarMenu} />
        </div>
      </div>
    );
  }
}

export default EntityRuleListPage;
